<!-- =========================================================================================
  File Name: ClientEdit.vue
  Description: Client Edit page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.con-img-upload {
  background: #efeeee;
}
.custom-domain-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.input-wdt {
  width: 70%;
  margin-right: 15px;
}
.auth-check {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.button-wrap {
  text-align: right;
}
</style>
<template>
  <vx-card v-if="client_data">
    <div slot="no-body" class="tabs-container px-6 pt-6">
      <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
        <vs-tab label="Client Info" icon-pack="feather" icon="icon-info">
          <div class="tab-text">
            <client-edit-tab-info class="mt-4" :data="client_data" />
          </div>
        </vs-tab>
        <vs-tab label="Settings" disabled="true" icon-pack="feather" icon="icon-settings">
          <div class="tab-text">
            <client-edit-tab-settings class="mt-4" :data="client_data" />
          </div>
        </vs-tab>
        <vs-tab label="Branding" disabled="true" icon-pack="feather" icon="icon-settings">
          <div class="tab-text">
            <client-edit-tab-branding class="mt-4" :data="BrandingJson" />
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
  </vx-card>
</template>
<script>
import ClientEditTabInfo from "./ClientEditTabInfo.vue";
import ClientEditTabSettings from "./ClientEditTabSettings.vue";
import ClientEditTabBranding from "./ClientEditTabBranding.vue";

// Store Module
import moduleClientManagement from "@/store/client-management/moduleClientManagement.js";

export default {
  components: {
    ClientEditTabInfo,
    ClientEditTabSettings
  },
  data() {
    return {
      client_data: null,
      client_not_found: false,
      BrandingJson: null,
      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    };
  },
  watch: {
    activeTab() {
      this.fetch_client_data(this.$route.params.clientId);
    }
  },
  methods: {
    fetch_client_data(ClientId) {
      if (ClientId === undefined) {
        ClientId = null;
      }
      this.$store
        .dispatch("clientManagement/fetchClient", null)
        .then(res => {
          this.client_data = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.client_not_found = true;
            return;
          }
          console.error(err);
        });
    }
  },
  created() {
    //debugger;
    // Register Module clientManagement Module
    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
    this.fetch_client_data();
  }
};
</script>

